import type { StreamingService } from "../types";

import { SpotifyPlayer } from "./spotify_player";
import type { ServicePlayer } from "./service_player";
import { ApplePlayer } from "./apple_player";
import type CMSConnector from "../connector";
import { MockPlayer } from "./mock_player";

/**
 * Returns a player for the given streaming service. This uses the default client instance for
 * the corresponding service. If you need to use a different client instance,
 * use the constructor of the player directly.
 */
export function playerFromService(
  service: StreamingService,
  cms: CMSConnector,
  playerArgs: any[] = []
): ServicePlayer {
  // @ts-ignore
  if (window && (window.TESTING || window._UMG_MOCK_PLAYER)) {
    // Playwright tests set this flag, see fan-heatmap/server/tests/client/...
    return new MockPlayer(cms);
  }
  if (service === "spotify") {
    return new SpotifyPlayer(...playerArgs);
  } else if (service === "apple") {
    return new ApplePlayer(...playerArgs);
  }
  throw new Error(`Player not implemented for ${service}`);
}

export { SpotifyPlayer, type ServicePlayer, ApplePlayer };
